import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import style from './SearchBarDropdown.module.less';
import { CheckboxButton, Button } from '../../index';

export default function SearchBarDropdown({
  isOpen = false,
  contentType = 'resources',
  setContentType,
  grade = '',
  setGrade,
  onSubmit,
}) {
  useEffect(() => {}, [isOpen]);

  const popularSearches = [
    {
      href: '/resources/ela/',
      text: 'Reading',
    },
    {
      href: '/resources/money-math/',
      text: 'Money',
    },
    {
      href: '/resources/fractions/',
      text: 'Fractions',
    },
    {
      href: '/resources/sight-words/',
      text: 'Sight Words',
    },
    {
      href: '/resources/multiplication/',
      text: 'Multiplication',
    },
  ];

  const contentTypeOptions = {
    resources: 'All',
    worksheets: 'Worksheets',
    games: 'Games',
    'guided=lessons': 'Guided Lessons',
    'lesson-plans': 'Lesson Plans',
  };

  const gradeOptions = {
    '': 'All',
    preschool: 'Pre-K',
    kindergarten: 'K',
    'first-grade': '1st',
    'second-grade': '2nd',
    'third-grade': '3rd',
    'fourth-grade': '4th',
    'fifth-grade': '5th',
  };

  const renderPopularSearches = popularSearches => {
    const links = popularSearches.map((link, i) => {
      return (
        <a href={link.href} key={`popular-search-${i}`}>
          {(i ? ', ' : '') + link.text}
        </a>
      );
    });

    return <>Popular searches: {links}</>;
  };

  const renderCheckboxes = (options, selected, clickHandler) => {
    return Object.entries(options).map(([key, value], i) => {
      return (
        <CheckboxButton
          selected={key === selected}
          clickHandler={() => clickHandler(key)}
          key={`search-bar-dropdown-checkbox-button-${i}`}
        >
          <label className={style['checkbox-text']}>{value}</label>
        </CheckboxButton>
      );
    });
  };

  const contentTypeCheckboxes = renderCheckboxes(
    contentTypeOptions,
    contentType,
    setContentType
  );
  const gradeCheckboxes = renderCheckboxes(gradeOptions, grade, setGrade);

  return (
    <div className={clsx(style.outer, { [style.hide]: !isOpen })}>
      <div className={style.inner}>
        <div className={style.popular}>
          {renderPopularSearches(popularSearches)}
        </div>
        <div>
          <span className={style['checkbox-title']}>Activity types</span>
          <div className={style.checkboxes}>{contentTypeCheckboxes}</div>
        </div>
        <div>
          <span className={style['checkbox-title']}>Grade level</span>
          <div className={style.checkboxes}>{gradeCheckboxes}</div>
        </div>
        <div className={style['button-container']}>
          <Button size="large" onClick={onSubmit} className={style['button']}>
            Search
          </Button>
        </div>
      </div>
    </div>
  );
}

SearchBarDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired,
  setContentType: PropTypes.func,
  grade: PropTypes.string.isRequired,
  setGrade: PropTypes.func,
  onSubmit: PropTypes.func,
};
